import React, { useEffect, useCallback, useRef } from 'react';
import classnames from 'classnames';
import Modal from 'react-modal';
import { ThemeOverride, SisuContext } from '../Context';
import { ThemeOptions } from '../publicSession/types';
import CloseButtonThin from '../Primitives/CloseButton';
import CloseIconBold from '../Icons/CloseBold';
import IconButton from '../Button/IconButton';
import ErrorBoundary from '../ErrorBoundary';
import { useBodyScrollLock } from '../utils/hooks/useBodyScollLock';
import { PopupScrollableContext } from './PopupScrollableContext';
import s from './Popup.scss';
var Popup = function (_a) {
    var _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, onRequestClose = _a.onRequestClose, width = _a.width, height = _a.height, className = _a.className, closeBtnClassName = _a.closeBtnClassName, closeBtnDisableDefaultColors = _a.closeBtnDisableDefaultColors, closeBtnSize = _a.closeBtnSize, _c = _a.contentClassName, contentClassName = _c === void 0 ? className : _c, contentLabel = _a.contentLabel, disableAriaHide = _a.disableAriaHide, _d = _a.withCloseButton, withCloseButton = _d === void 0 ? true : _d, overlayClassName = _a.overlayClassName, forceTheme = _a.forceTheme, allowThemeSkins = _a.allowThemeSkins, children = _a.children;
    var contentRef = useRef(null);
    var _e = useBodyScrollLock(), onLock = _e.onLock, onUnlock = _e.onUnlock, setScrollableRef = _e.setScrollableRef;
    var style = {
        content: {
            width: width || false,
            height: height || false,
        },
    };
    useEffect(function () {
        var focusedEl = document.activeElement;
        var contentEl = contentRef.current;
        var isFocused = function (el) { return el === focusedEl || el.contains(focusedEl); };
        var needsFocus = contentEl && (!focusedEl || !isFocused(contentEl));
        var focusTimeout;
        if (needsFocus) {
            // useEffect is supposed to be invoked when everything mounted, but without this timeout something else steals the focus
            focusTimeout = setTimeout(function () { return contentEl.focus(); }, 100);
        }
        return function () { return focusTimeout && clearTimeout(focusTimeout); };
    }, []);
    var setContentRef = function (instance) {
        contentRef.current = instance;
        setScrollableRef(instance);
    };
    var onClose = useCallback(function () {
        onUnlock();
        onRequestClose && onRequestClose();
    }, [onRequestClose, onUnlock]);
    return (React.createElement(Modal, { isOpen: isOpen, onAfterOpen: onLock, onRequestClose: onClose, className: classnames(s['modal'], className), overlayClassName: classnames(s['overlay'], overlayClassName), contentLabel: contentLabel, style: style, ariaHideApp: !disableAriaHide, contentRef: setContentRef },
        React.createElement(ThemeOverride, { className: classnames(!allowThemeSkins && 'no-theme-skin', contentClassName), theme: forceTheme || ThemeOptions.LIGHT },
            withCloseButton && (React.createElement(SisuContext.Consumer, null, function (isSisu) {
                return isSisu ? (React.createElement(CloseButtonThin, { className: classnames(s['sisu-close-button'], closeBtnClassName), onClick: onClose })) : (React.createElement(IconButton, { className: s['close-button'], onClick: onClose, noHoverEffect: true },
                    React.createElement(CloseIconBold, { className: closeBtnClassName, size: closeBtnSize, disableDefaultColors: closeBtnDisableDefaultColors })));
            })),
            React.createElement(ErrorBoundary, null,
                React.createElement(PopupScrollableContext.Provider, { value: { setScrollableContentRef: setScrollableRef } }, children)))));
};
Popup.displayName = 'Popup';
export default Popup;
//# sourceMappingURL=Popup.js.map